import styled from 'styled-components';

const QuestionContainer = styled.div`
  border-top: 1px solid #d7dbe3;
  padding: 64px 0px;
`;

export default QuestionContainer;
